import { Helmet } from "react-helmet";
import BreakPanel from "../components/hobbies/BreakPanel";
import GamesPanel from "../components/hobbies/GamesPanel";
import INFO from "../data/user";
import "./styles/hobbies.css";

const Hobbies = () => {
	return (
		<>
			<Helmet>
				<title>{`Off the Clock | ${INFO.main.title}`}</title>
				<meta
					name="description"
					content="Keefe Oentoro — breakdance and video games outside of code."
				/>
			</Helmet>

			<div className="page-content hobbies-page">
				<div className="hobbies-wrapper">
					<div className="hobbies-top">
						<header className="hobbies-header">
							<div className="hobbies-eyebrow mono">
								● PORTFOLIO B-SIDE
							</div>
							<h1 className="hobbies-title">Off the Clock</h1>
							<p className="hobbies-sub">
								What I do well...off the clock. Breaking,
								photos, and games.
							</p>
						</header>
						<GamesPanel />
					</div>

					<BreakPanel />
				</div>
			</div>
		</>
	);
};

export default Hobbies;
